// SaveNotificacion.tsx
import { Notificacion, NotificacionForm } from "../../types";
import { useForm } from "react-hook-form";
import { ROUTER_PATHS } from "@/shared";
import { useNavigate } from "react-router-dom";
import { CustomTextField, SingleFormBoxScene } from "@/shared/components/ui";
import { useEffect, useState } from "react";
import {
  useFetchPostNotificacion,
  useFetchPutNotificacion,
} from "@/shared/actions";
import { notificacionSchema } from "../../utils";
import { yupResolver } from "@hookform/resolvers/yup";

type SaveNotificacionProps = {
  titulo: string;
  data?: Notificacion | null;
};

export default function SaveNotificacion({ titulo, data }: SaveNotificacionProps) {
  const returnUrl = ROUTER_PATHS.control_cambios.notificacionNav;
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  const createNotificacion = useFetchPostNotificacion({
    navigate,
    returnUrl,
  });
  const updateNotificacion = useFetchPutNotificacion(navigate, returnUrl);

  const form = useForm<NotificacionForm>({
    resolver: yupResolver(notificacionSchema),
    mode: "onChange",
    defaultValues: {
      nombre: "",
      correo: "",
      estado: true,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  const onSave = () => {
    if (!isValid) return;
    if (data?.notificacionId) {
      return updateNotificacion.mutate({
        id: data.notificacionId,
        data: form.getValues() as any,
      });
    }
    return createNotificacion.mutate({
      ...form.getValues(),
    });
  };

  useEffect(() => {
    if (data) {
      setShrink(true);
      reset({ ...data });
    }
  }, [data]);

  return (
    <SingleFormBoxScene
      titlePage={titulo}
      onCancel={() => navigate(returnUrl)}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ""}
        shrink={shrink}
      />
      <CustomTextField
        label="Correo"
        name="correo"
        control={form.control}
        defaultValue={form.getValues().correo || ""}
        error={errors.correo}
        helperText={errors.correo?.message ?? ""}
        shrink={shrink}
      />
    </SingleFormBoxScene>
  );
}
